// extracted by mini-css-extract-plugin
module.exports = {"container":"blogHome_container__o5Jgz","section":"blogHome_section__poImt","bgGrey":"blogHome_bgGrey__508sv","lcResourcesContainer":"blogHome_lcResourcesContainer__ES8tx"};